import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

let client;
let clientKey;

/**
 * Browser-only client using the publishable (anon) key — never the service role key.
 * Recreates the client if env changes (e.g. HMR) so a stale key is not reused.
 */
export function getSupabaseBrowser() {
  if (!url || !anonKey) return null;
  if (client && clientKey === `${url}::${anonKey}`) return client;
  clientKey = `${url}::${anonKey}`;
  client = createClient(url, anonKey, {
    auth: {
      persistSession: false,
      autoRefreshToken: false,
      detectSessionInUrl: false,
    },
  });
  return client;
}
